import { categories } from "@/mocks/comics";

const navLinks = [
  { label: "首页", href: "#home" },
  { label: "核心功能", href: "#features" },
  { label: "热门漫画", href: "#comics" },
  { label: "主题分类", href: "#categories" },
  { label: "使用教程", href: "#how" },
  { label: "常见问题", href: "#faq" },
  { label: "联系反馈", href: "#contact" },
];

export default function Footer() {
  return (
    <footer className="bg-primary-950 text-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <a href="#home" className="flex items-center gap-2.5" aria-label="洒洒漫画网">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-book-2-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-bold text-background-50">
                洒洒<span className="text-accent-400">漫画网</span>
              </span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-100/70">
              主打漫画下载缓存、全集打包离线收藏的阅读平台。
              让每一部喜欢的作品，都能随时随地离线畅读。
            </p>
          </div>

          <nav aria-label="快速导航">
            <h3 className="text-sm font-bold uppercase tracking-widest text-accent-400">
              快捷导航
            </h3>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-background-100/70 transition-colors hover:text-background-50"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <nav aria-label="主题分类">
            <h3 className="text-sm font-bold uppercase tracking-widest text-accent-400">
              热门主题
            </h3>
            <ul className="mt-4 grid grid-cols-1 gap-2.5">
              {categories.slice(0, 6).map((c) => (
                <li key={c.key}>
                  <a
                    href="#categories"
                    className="text-sm text-background-100/70 transition-colors hover:text-background-50"
                  >
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div>
            <h3 className="text-sm font-bold uppercase tracking-widest text-accent-400">
              联系反馈
            </h3>
            <ul className="mt-4 space-y-2.5 text-sm text-background-100/70">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base" aria-hidden="true"></i>
                hello@sasa-manhua.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base" aria-hidden="true"></i>
                工作日 24 小时内回复
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-download-cloud-2-line text-base" aria-hidden="true"></i>
                支持手机 / 平板 / 电脑
              </li>
            </ul>
            <div className="mt-5 flex items-center gap-2">
              {["ri-wechat-fill", "ri-weibo-fill", "ri-bilibili-fill"].map((icon) => (
                <a
                  key={icon}
                  href="#contact"
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-background-50/10 text-background-100 transition-colors hover:bg-primary-500 hover:text-background-50"
                  aria-label="洒洒漫画网社交媒体入口"
                >
                  <i className={`${icon} text-lg`} aria-hidden="true"></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-50/10 pt-6 sm:flex-row">
          <p className="text-xs text-background-100/60">
            © {new Date().getFullYear()} 洒洒漫画网 · 缓存漫画，离线畅读
          </p>
          <p className="text-xs text-background-100/60">
            本站内容仅供参考，请于合法范围内使用相关服务
          </p>
        </div>
      </div>
    </footer>
  );
}